<template>
  <div class="fulfillment-question-main">
    <div v-if="!ready">
      <div class="fulfillment-title-container">
        <div class="fulfillment-back-container" v-if="hasGoBack" @click="$emit('goBack')">
          <svg role="img" viewBox="0 0 192 512">
            <path :fill="color" :d="ffBackContainerPath" />
          </svg>
        </div>
        <h1 class="fulfillment-title">Verificación de tu Identidad</h1>
      </div>
      <p class="fulfillment-paragraph">
        Por seguridad, debemos validar tu identidad digital
      </p>
      <ul class="fulfillment-list">
        <li>Verificación de datos</li>
        <li>Preguntas de Seguridad</li>
      </ul>
      <div class="fulfillment-footer-section">
        <div class="fulfillment-col">
          <a
            v-if="_events.questionsclientformleaveauth"
            @click="$emit('questionsclientformleaveauth')"
            class="fulfillment-link"
          >
            Volver
          </a>
        </div>
        <div class="fulfillment-col fulfillment-right">
          <button
            class="fulfillment-button fulfillment-blue"
            v-bind:style="{ backgroundColor: color }"
            @click="ready = true"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
    <div v-if="ready">
      <div class="fulfillment-title-container">
        <h1 class="fulfillment-title">Verificación de datos</h1>
      </div>
      <span class="fulfillment-paragraph-step-2">
        Ingresa los datos de tu cédula de identidad vigente
      </span>

      <div v-if="error" class="fulfillment-message-error fulfillment-mb-20">
        <span class="fulfillment-round fulfillment-message-error-icon fulfillment-v-middle">!</span>
        <span class="fulfillment-v-middle">Los datos ingresados no coinciden</span>
      </div>

      <div class="fulfillment-form">
        <div class="fulfillment-mb-20">
          <div class="fulfillment-input-title">RUT</div>
          <input type="text" :value="rut" name="rut" disabled placeholder="Ejemplo: 8455411-9" />
        </div>

        <div class="fulfillment-mb-20">
          <div class="fulfillment-input-title">Número de Documento o Serie</div>
          <input
            type="text"
            @keyup="onlyAlphaNumeric"
            v-model="serial"
            @paste="noPaste"
            name="serial"
            placeholder="A000000000"
            maxlength="10"
          />
        </div>

        <a @click="showModal = true" class="fulfillment-link" v-bind:style="{ color: color }">
          ¿Dónde encuentro el número de serie?
        </a>
      </div>

      <div class="fulfillment-footer-section">
        <div class="fulfillment-col">
          <a @click="$emit('goBack')" class="fulfillment-link" v-bind:style="{ color: '#aeaeae' }">Volver</a>
        </div>
        <div class="fulfillment-col fulfillment-right">
          <button
            v-if="!sending"
            v-bind:style="{
              backgroundColor: serial && serialHasFormat ? color : '#e6e6e6'
            }"
            v-bind:class="{
              'fulfillment-blue': serial && serialHasFormat,
              'fulfillment-disabled': !serialHasFormat
            }"
            class="fulfillment-button"
            @click="sendInfomation"
          >
            Continuar
          </button>
          <button v-else class="fulfillment-button disabled">
            <svg
              class="fulfillment-spinner"
              height="40"
              width="40"
              :style="{ strokeDasharray: '132px', strokeDashoffset: '80px' }"
            >
              <circle cx="20" cy="20" r="10" :stroke="color" stroke-width="4" fill="#e6e6e6" />
            </svg>
          </button>
        </div>
      </div>
      <modal v-if="showModal" @closemodal="showModal = false" :color="color">
        <div slot="header">
          <p class="fulfillment-modal-header">Encuentra el número de serie o documento</p>
        </div>
        <div slot="body">
          <div class="fulfillment-rut-pictures-container">
            <div class="fulfillment-col fulfillment-pr-15">
              <strong class="fulfillment-rut-detail">Carnet Nuevo: Número de documento</strong>
              <img
                class="fulfillment-w-100"
                src="https://static.dx.principal.cl/fulfillment/assets/auth/kba/carnet_front.png"
                alt="carnet frontal"
              />
            </div>
            <div class="fulfillment-col fulfillment-pl-15">
              <strong class="fulfillment-rut-detail">Carnet Antiguo: Número de serie</strong>
              <img
                class="fulfillment-w-100"
                src="https://static.dx.principal.cl/fulfillment/assets/auth/kba/carnet_back.png"
                alt="carnet frontal"
              />
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import { rutValidator, rutFilter } from "vue-dni";
import modal from "./ModalComponent";

export default {
  name: "ClientForm",
  components: {
    modal
  },
  data() {
    return {
      serial: "",
      error: false,
      showModal: false,
      ready: true,
      sending: false,
      ffBackContainerPath:
        "M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 " +
        "17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z"
    };
  },
  props: {
    rut: { type: String, required: true },
    color: { type: String, default: "#0091DA" },
    hasGoBack: { type: Boolean, default: false }
  },
  methods: {
    sendInfomation() {
      this.error = false;
      if (rutValidator(this.rut) && this.serialHasFormat) {
        this.sending = true;
        this.$emit("questionssingleformauth", {
          rut: rutFilter(this.rut).replace(/\./g, ""), // String conteniendo el rut sin puntos y con guión
          idCardSerialNumber: this.serial // String contieniendo el numero de serie
        });
        this.$emit("identityCardVerificationReady");
      } else {
        this.error = true;
      }
    },
    noPaste: e => e.preventDefault(),
    onlyAlphaNumeric(e) {
      const {
        key,
        target: { value }
      } = e;
      this.serial =
        value.match(/^[A-Za-z]\d{0,9}$|^\d{0,9}$/) === null
          ? this.serial.replace(new RegExp(key, "g"), "")
          : this.serial.toUpperCase();
    }
  },
  computed: {
    serialHasFormat() {
      return this.serial.match(/[A-Za-z]\d{9}$|^\d{9}$/) !== null;
    }
  }
};
</script>

<style scoped>
.fulfillment-title-container {
  display: flex;
  align-items: center;
}

.fulfillment-question-main {
  color: #4a4a4a;
  padding: 15px;
  max-width: 600px;
  margin: auto;
}

.fulfillment-back-container {
  display: inline-flex;
  width: 20px;
  height: 32px;
  cursor: pointer;
}

.fulfillment-back-container svg {
  transform: scale(0.7);
  width: 32px;
}

.fulfillment-title {
  color: #0076cf;
  font-family: "FS Elliot Pro", sans-serif;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 35px;
  text-align: left;
}

.fulfillment-paragraph {
  font-size: 18px;
  margin-top: 0px;
}

.fulfillment-paragraph-step-2 {
  color: #464646;
  font-family: "FS Elliot Pro", sans-serif;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: left;
  width: 100%;

}

.fulfillment-v-middle {
  vertical-align: middle;
}
.fulfillment-mb-20 {
  margin-top: 20px;
}
.fulfillment-pl-15 {
  padding-left: 15px;
}
.fulfillment-pr-15 {
  padding-right: 15px;
}
.fulfillment-w-100 {
  width: 100%;
}

.fulfillment-modal-header {
  font-size: 20px;
  margin-bottom: 27px;
  padding-right: 50px;
  margin-top: 0px;
}

input[type="text"] {
  border-radius: 2px;
  line-height: 1;
  border: 1px solid #dedede;
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  color: #4d4e53;
  font-size: 16px;
}

.fulfillment-spinner {
  animation-duration: 1s;
  animation-name: spinner;
  animation-iteration-count: infinite;
}

@keyframes spinner {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.fulfillment-disabled {
  cursor: default;
  pointer-events: none;
  outline: none;
}

.fulfillment-list {
  padding-left: 20px;
  font-size: 18px;
  line-height: 1.5;
}

.fulfillment-list li {
  padding: 0px 10px;
}

.fulfillment-footer-section {
  display: table;
  width: 100%;
  margin-top: 27px;
}

.fulfillment-rut-pictures-container {
  margin: 10px auto;
}

.fulfillment-col {
  display: table-cell;
  vertical-align: middle;
}
.fulfillment-form {
  max-width: 345px;
}
.fulfillment-right {
  text-align: right;
}
.fulfillment-href {
  text-decoration: underline;
  cursor: pointer;
}

.fulfillment-input-title {
  color: #4a4a4a;
  font-family: "FS Elliot Pro", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  text-align: left;
}

.fulfillment-link {
  color: #0091da;
  font-weight: bold;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  padding-top: 10px;
}

.fulfillment-form .fulfillment-link {
  display: block;
}

.fulfillment-round {
  border-radius: 100%;
}

.fulfillment-button {
  min-height: 44px;
  min-width: 149px;
  border-radius: 22px;
  background-color: #e6e6e6;
  border: none;
  font-weight: bold;
  color: #757575;
  font-size: 16px;
  cursor: pointer;
}

.fulfillment-message-error {
  color: #b30000;
  border: 1px solid;
  border-radius: 5px;
  vertical-align: middle;
}

.fulfillment-message-error-icon {
  background-color: #b30000;
  color: white;
  width: 24px;
  height: 24px;
  text-align: center;
  display: inline-block;
  line-height: 1;
  font-size: 24px;
  font-weight: bold;
  margin: 15px;
}

.fulfillment-rut-detail {
  display: block;
  margin-bottom: 10px;
  font-size: 15px;
}

.fulfillment-blue {
  background-color: #0091da;
  color: white;
  outline: none;
}
input,
button {
  outline: none;
  font-family: "FS Elliot Pro", Helvetica, Arial, sans-serif;
}
.fulfillment-blue-text {
  color: #0091da;
}

@media screen and (max-width: 674px) {
  .fulfillment-rut-pictures-container .fulfillment-col {
    display: block;
    text-align: center;
    padding: 0px 10px 10px;
    margin-bottom: 23px;
  }

  .fulfillment-rut-pictures-container img {
    max-width: 290px;
  }
}

@media screen and (max-width: 480px) {
  .fulfillment-form {
    max-width: 100%;
  }
  .fulfillment-form .fulfillment-link {
    text-align: right;
  }
}
</style>
